<template>
    <div class="login">
      <form @submit.prevent="login" >
        <label for="username">Usuario</label>
        <input type="text" v-model="usuario.username" id="username" required>
        <label for="password">Contraseña</label>
        <input type="password" v-model="usuario.password" id="password" required>
        <button type="submit">Iniciar sesión</button>
      </form>
      <!-- <div  >
        <button @click="logout">Cerrar sesión</button>
      </div> -->
      <div v-if="mensajeError" class="error-message">
        {{ mensajeError }}
      </div>
    </div>
  </template>
  
  <script>
  
  export default {
    data() {
      return {
        usuario: {
          username: null,
          password: null,
        },
        mensajeError: null,
      };
    },
    methods: {
      // Enviar solicitud
      login() {
        const dataUsuario = new FormData();
        dataUsuario.append('username', this.usuario.username);
        dataUsuario.append('password', this.usuario.password);
  
        fetch('/php/login.php?action=login', {
          method: 'POST',
          body: dataUsuario,
        })
          .then(response => response.json())
          .then(data => {
            if (!data.error) {
              
              this.$router.push('/listar');
              sessionStorage.setItem('isAuthenticated', true);
            } else {
              this.mensajeError = 'Usuario o contraseña incorrectos';
              console.error('Error en el inicio de sesión:', data.message);
            }
          })
          .catch(error => console.error('Error en el inicio de sesión:', error));
       
  
      },
     
    },
  };
  </script>
  <style>
  
  </style>
  
  
  
  